// extracted by mini-css-extract-plugin
export default {"text":"DeletePublicPasswordConfirmModal__text--kUznq"};